define("shared/errors/ember-exex-compat", ["exports", "lodash", "later/services/errors", "shared/utils/constants/errors"], function (_exports, _lodash, _errors, _errors2) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.EmberExexCompat = void 0;
  _exports.fallbackResolve = fallbackResolve;
  0; //eaimeta@70e063a35619d71f0,"lodash",0,"later/services/errors",0,"shared/utils/constants/errors"eaimeta@70e063a35619d71f
  function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  /**
   * A fallback for errors defined without a `resolve` function that
   * warns devs when calls to `resolve` are made, which indicates either
   * the error was improperly defined or that we shouldn't be calling
   * `resolve`.
   * @param this Caller
   */
  function fallbackResolve() {
    const noResolveMessage = 'No resolve function provided with error definition';
    if (this.errors) {
      this.errors.log(noResolveMessage, {}, _errors.ErrorSeverity.Warning);
    } else {
      console.warn(noResolveMessage);
    }
  }
  class EmberExexCompat extends Error {
    constructor() {
      super(...arguments);
      /** Error code which defaults to `0` but can be specified when creating instance */
      _defineProperty(this, "code", _errors2.DEFAULT_EXEX_ERROR_CODE);
      /** Error name which can only be specified when error constructor is defined */
      _defineProperty(this, "name", _errors2.DEFAULT_EXEX_ERROR_NAME);
      /** Error message which can be specified upon defining of error or instantiation */
      _defineProperty(this, "message", _errors2.DEFAULT_EXEX_ERROR_MESSAGE);
      /** Optional callback function that can be executed in a `catch` clause */
      _defineProperty(this, "resolve", fallbackResolve);
      /** Optional description of the error's occurrence */
      _defineProperty(this, "description", void 0);
      /** Optional data attached to the error when initialized */
      _defineProperty(this, "data", void 0);
    }
    withDescription(description) {
      if ((0, _lodash.isString)(description) && !(0, _lodash.isEmpty)(description)) {
        this.description = description;
      }
      return this;
    }
    withAdditionalData(additionalData) {
      if ((0, _lodash.isUndefined)(additionalData) || (0, _lodash.isEmpty)(additionalData)) {
        return this;
      }
      if (!this.data) {
        this.data = [];
      }
      this.data.push(JSON.stringify(additionalData));
      return this;
    }
    toJSON() {
      const json = {
        name: this.name,
        message: this.message,
        code: this.code
      };
      if (this.description) {
        json.description = this.description;
      }
      if (this.data) {
        json.data = this.data;
      }
      return json;
    }
    toString() {
      return `${this.name}: ${this.message}\n${JSON.stringify(this)}`;
    }
  }
  _exports.EmberExexCompat = EmberExexCompat;
});